import React from 'react';
import { Logout } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

/**
 * Shared logout confirmation dialog used by navbar and profile page.
 */
export default function LogoutConfirmDialog({ open, onClose, onConfirm }) {
  const { t } = useTranslation();

  if (!open) return null;

  const title =
    t('nav.logoutConfirmTitle', {
      defaultValue: t('profile.logoutConfirmTitle', 'Logout Confirmation'),
    });
  const message =
    t('nav.logoutConfirmMessage', {
      defaultValue: t('profile.logoutConfirmMessage', 'Are you sure you want to logout?'),
    });

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center">
            <Logout className="text-red-500" />
          </div>
          <div>
            <div className="font-semibold text-lg text-gray-900">{title}</div>
            <div className="text-sm text-gray-600">{message}</div>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors"
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors shadow"
          >
            {t('nav.logout')}
          </button>
        </div>
      </div>
    </div>
  );
}
